import { render, staticRenderFns } from "./store-enter.vue?vue&type=template&id=af0af4f6"
import script from "./store-enter.vue?vue&type=script&lang=ts"
export * from "./store-enter.vue?vue&type=script&lang=ts"
import style0 from "./store-enter.vue?vue&type=style&index=0&id=af0af4f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports